// src/utils/classnames.ts
import { mergeProps } from "solid-js";
import { Dynamic, createComponent } from "solid-js/web";
import { twMerge } from "tailwind-merge";
var cn = (...inputs) => {
  const tokens = [];
  inputs.forEach((item) => {
    if (!item) return;
    if (typeof item === "string") {
      return tokens.push(item);
    }
    if (typeof item === "object") {
      if (Array.isArray(item)) {
        return tokens.push(cn(...item));
      }
      for (const key in item) {
        item[key] && tokens.push(key);
      }
    }
  });
  return twMerge(...tokens);
};
var cva = (config) => (props, ...className) => {
  const { base, variants, computed, defaults } = config;
  for (const key in defaults) {
    if (props[key] == null) {
      props[key] = defaults[key];
    }
  }
  const values = [base];
  if (variants != null) {
    for (const key in variants) {
      const variant = variants[key];
      const value = props[key];
      values.push(variant[value]);
    }
  }
  computed != null && values.push(computed(props));
  return cn(...values, ...className);
};
var isTemplateStringsArray = (value) => value?.raw != null;
var createTwc = (tag) => {
  return (config, ...rest) => {
    const css = isTemplateStringsArray(config) ? String.raw(config, ...rest) : cva(config);
    return (props) => {
      const className = typeof css === "function" ? css(props) : css;
      const merged = mergeProps(props, {
        get component() {
          return tag;
        },
        get class() {
          return cn(className, "class" in props && props.class);
        }
      });
      return createComponent(Dynamic, merged);
    };
  };
};
var twc = new Proxy(createTwc, { get: (_, tag) => createTwc(tag) });

export {
  cn,
  cva,
  twc
};
